import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import './AuthorizeCodeModal.css'

function AuthorizeCodeModal ({ modal, modalState, onSubmit, user }) {
  const [code, setCode] = useState(['', '', '', '', '', ''])
  const [timeLeft, setTimeLeft] = useState(300)

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const handleInputChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newCode = [...code]
      newCode[index] = value
      setCode(newCode)

      // Move to the next input
      if (value && index < 5) {
        document.getElementById(`digit-${index + 1}`).focus()
      }
    }
  }

  const handleSubmit = () => {
    const fullCode = code.join('')
    setTimeLeft(300)
    setCode(['', '', '', '', '', ''])
    if (fullCode.length === 6) {
      onSubmit(fullCode)
    } else {
      toast.warning('Por favor, complete el código de 6 dígitos.')
    }
  }

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60)
    const seconds = timeLeft % 60
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }

  return (
    <div
      className='modal fade'
      ref={modal}
      id='authorizeCodeModal'
      tabIndex='-1'
      aria-labelledby='authorizeCodeModalLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='authorizeCodeModalLabel'>Ingrese el código</h5>
            <button
              type='button'
              className='btn-close'
              onClick={() => modalState.hide()}
            />
          </div>
          <div className='modal-body'>
            <p>{`Ingrese el código de 6 dígitos enviado al correo ${user.email}`}</p>
            <div className='code-inputs'>
              {code.map((digit, index) => (
                <input
                  key={index}
                  id={`digit-${index}`}
                  type='text'
                  maxLength='1'
                  className='form-control code-input'
                  value={digit}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
              ))}
            </div>
            <div className='timer'>Tiempo restante: {formatTime()}</div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn main-btn authorize-code-btn'
              onClick={handleSubmit}
              disabled={timeLeft === 0}
            >
              Verificar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthorizeCodeModal
